<template>
  <div style="float: right; padding-right: calc(0.5%)">
    <nav>
      <ul
        role="menubar"
        aria-disabled="false"
        aria-label="Pagination"
        class="pagination b-pagination pagination-sm"
      >
        <template v-if="currentPage == 1">
          <li role="none presentation" class="page-item disabled">
            <a
              role="menuitem"
              tabindex="-1"
              aria-label="Goto next page"
              target="_self"
              class="page-link"
              ><span aria-hidden="true" class="page-selector">«</span></a
            >
          </li>
        </template>
        <template v-else>
          <li role="none presentation" class="page-item">
            <router-link
              :to="
                '/productos/' +
                  critFilter +
                  '/1/' +
                  cateFilter +
                  '/' +
                  subcateFilter +
                  '/' +
                  caliberFilter +
                  '/' +
                  brandFilter +
                  (queryFilter == 0 ? '' : '/' + queryFilter) +
                  ''
              "
              role="menuitem"
              tabindex="-1"
              aria-label="Goto next page"
              target="_self"
              class="page-link"
              ><span aria-hidden="true" class="page-selector">«</span></router-link
            >
          </li>
        </template>
        <template v-if="currentPage > 1">
          <li role="none presentation" class="page-item" aria-hidden="true">
            <router-link
              :to="
                '/productos/' +
                  critFilter +
                  '/' +
                  (currentPage - 1) +
                  '/' +
                  cateFilter +
                  '/' +
                  subcateFilter +
                  '/' +
                  caliberFilter +
                  '/' +
                  brandFilter +
                  (queryFilter == 0 ? '' : '/' + queryFilter) +
                  ''
              "
            >
              <span class="page-link page-selector" aria-hidden="true">‹</span>
            </router-link>
          </li>
        </template>
        <template v-else>
          <li role="none presentation" class="page-item disabled" aria-hidden="true">
            <span class="page-link page-selector">‹</span>
          </li>
        </template>
        <li
          v-for="page in availablePages"
          :key="page"
          role="none presentation"
          :class="['page-item', page == currentPage ? 'active' : '']"
        >
          <router-link
            :to="
              '/productos/' +
                critFilter +
                '/' +
                page +
                '/' +
                cateFilter +
                '/' +
                subcateFilter +
                '/' +
                caliberFilter +
                '/' +
                brandFilter +
                (queryFilter == 0 ? '' : '/' + queryFilter) +
                ''
            "
            role="menuitemradio"
            tabindex="-1"
            aria-label="Goto page 2"
            aria-checked="false"
            aria-posinset="2"
            aria-setsize="4"
            target="_self"
            class="page-link page-selector"
            >{{ page }}</router-link
          >
        </li>
        <template v-if="currentPage == finalPage">
          <li role="none presentation" class="page-item disabled">
            <a
              role="menuitem"
              tabindex="-1"
              aria-label="Goto next page"
              target="_self"
              class="page-link"
              ><span aria-hidden="true" class="page-selector">›</span></a
            >
          </li>
        </template>
        <template v-else>
          <li role="none presentation" class="page-item" aria-hidden="true">
            <router-link
              :to="
                '/productos/' +
                  critFilter +
                  '/' +
                  (parseInt(currentPage) + 1) +
                  '/' +
                  cateFilter +
                  '/' +
                  subcateFilter +
                  '/' +
                  caliberFilter +
                  '/' +
                  brandFilter +
                  (queryFilter == 0 ? '' : '/' + queryFilter) +
                  ''
              "
            >
              <span class="page-link page-selector" aria-hidden="true">›</span>
            </router-link>
          </li>
        </template>
        <template v-if="currentPage == finalPage">
          <li role="none presentation" class="page-item disabled">
            <a
              role="menuitem"
              tabindex="-1"
              aria-label="Goto next page"
              target="_self"
              class="page-link"
              ><span class="page-selector" aria-hidden="true">»</span></a
            >
          </li>
        </template>
        <template v-else>
          <li role="none presentation" class="page-item">
            <router-link
              :to="
                '/productos/' +
                  critFilter +
                  '/' +
                  finalPage +
                  '/' +
                  cateFilter +
                  '/' +
                  subcateFilter +
                  '/' +
                  caliberFilter +
                  '/' +
                  brandFilter +
                  (queryFilter == 0 ? '' : '/' + queryFilter) +
                  ''
              "
              role="menuitem"
              tabindex="-1"
              aria-label="Goto next page"
              target="_self"
              class="page-link"
            >
              <span class="page-selector" aria-hidden="true">»</span>
            </router-link>
          </li>
        </template>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  props: [
    'currentPage',
    'availablePages',
    'finalPage',
    'critFilter',
    'cateFilter',
    'subcateFilter',
    'caliberFilter',
    'brandFilter',
    'queryFilter',
  ],
};
</script>
